import { render } from "./ServiceUnitCalibration.vue?vue&type=template&id=80b8eb1c&scoped=true"
import script from "./ServiceUnitCalibration.vue?vue&type=script&lang=js"
export * from "./ServiceUnitCalibration.vue?vue&type=script&lang=js"

import "./ServiceUnitCalibration.vue?vue&type=style&index=0&id=80b8eb1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80b8eb1c"]])

export default __exports__